import { createApi } from '@reduxjs/toolkit/query/react';
import type { TenantDto } from '@/types';
import { baseQueryWithRetry } from './baseQuery';
import { TAG_TENANT } from '@/store/tagTypes';

const TENANT_STORAGE_KEY = 'scribia_tenant_current';

function getTenantFromStorage(): TenantDto | null {
  try {
    const raw = localStorage.getItem(TENANT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function saveTenantToStorage(tenant: TenantDto): void {
  try {
    localStorage.setItem(TENANT_STORAGE_KEY, JSON.stringify(tenant));
  } catch {
    // localStorage full or unavailable
  }
}

export const tenantApi = createApi({
  reducerPath: 'tenantApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: [TAG_TENANT],
  endpoints: (builder) => ({
    getCurrentTenant: builder.query<TenantDto, void>({
      query: () => '/tenant/current',
      providesTags: [TAG_TENANT],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const cached = getTenantFromStorage();
        if (cached) {
          dispatch(
            tenantApi.util.updateQueryData('getCurrentTenant', undefined, () => cached),
          );
        }
        try {
          const { data } = await queryFulfilled;
          saveTenantToStorage(data);
        } catch {
          // API error — keep stale cache
        }
      },
    }),
  }),
});

export const { useGetCurrentTenantQuery } = tenantApi;
